module.exports = __webpack_public_path__ + "img/flt_pt_fine_bolts.prt.2e03aa24.jpg";